module.exports = __webpack_public_path__ + "assets/ac6c87884f0c8a988e09ca63c2a92878.mp3";